import React, { useEffect, useState } from "react";
//mui components
import {
  Grid,
  Box,
  Typography,
  TextField,
  Button,
  Tab,
  Tooltip,
  IconButton,
  CircularProgress,

} from "@mui/material";
import { TabContext, TabList, TabPanel } from "@mui/lab";
// icons
import {
  Dashboard,
  BookmarkBorder,
  BackupOutlined,
  Add,
} from "@mui/icons-material";

// components
// import Acheivement from "../popups/Acheivement";
// import Activity from "../popups/Activity";
// import ViewGoal from "../popups/ViewGoal";
// import EditGoal from "../popups/EditGoal";
// import CheckIn from "../popups/Checkin";
import CreateGoal from "../popups/CreateGoal";
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';

import SelectableSearch from "../../../Base/views/SelectableSearch";
import ArrowBackButton from "../../../Base/views/ArrowBackButton";
import Popup from "../../../Base/views/Popup";
import ConfirmationDialog from "../../../Base/views/ConfirmationDialog";

import GoalCard, { GoalCardSkeleton } from "./GoalCard";
import { DeleteManageGoalAction, GetManageGoalAction, GetMyGoalAction } from "../../../../../store/Employee/PMSystem/Action";
import { useDispatch, useSelector } from "react-redux";
import { isAdminOwner } from "../../../Base/helper/baseFunctions";
import history from "../../../../../history";

export default function ManageGoal() {
  // const [acheivementpopup, setAcheivementpopup] = useState(false);
  // const [activitypopup, setactivitypopup] = useState(false);

  const [createpopup, setcreatepopup] = useState(false);
  // const [checkinpopup, setcheckinpopup] = useState(false);
  // const [viewpopup, setviewpopup] = useState(false);
  // const [linkedActivities, setlinkedActivities] = useState([]);
  const [yearplan] = useState({
    load: false,
    values: [
      { value: "Milestone Plan 2024", label: "Milestone Plan 2024" },
      { value: "Milestone Plan 2023", label: "Milestone Plan 2023" },
    ],
  });


  const [yearplanvalue, setyearplanvalue] = useState("");
  const [value, setValue] = useState("1");
  const [searchValue, setsearchvalue] = useState("");
  const [error, setError] = useState("");
  const teammembers = [
    {
      name: "Deepthi",
      designation: "software Developer",
    },
    {
      name: "Sanika Sawant",
      designation: "Scrum Master",
    },
    {
      name: "Raj Kumar",
      designation: "Fullstack Developer",
    },
    {
      name: "Navroj",
      designation: "Frontend Developer",
    },
  ];
  const [team, setteam] = useState(teammembers);



  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleInputChange = (event, newValue) => {
    if (["goalplanning"].includes(event)) {
      if (newValue) {
        setyearplanvalue(newValue);
        // validate();
      }
    }
  };
  const handlememberSearch = (e) => {
    const newSearchValue = e.target.value;
    setsearchvalue(newSearchValue);
    if (newSearchValue === "") {
      setteam(teammembers);
    } else {
      const searchdata = team?.filter((item) => 
        item.name.toLowerCase().includes(newSearchValue.toLowerCase())
      ); 
      setteam(searchdata);
    }
  };
  // const validate = () => {
    //   yearplanvalue === "" ? setError("Goal planning Required") : setError(" ");
    // };
    const dispatch = useDispatch();
    const [currentGoal, setCurrentGoal] = useState(null);
    const [isExporting, setIsExporting] = useState(false);
    const [openDialog, setOpenDialog] = useState(false);
    const [popupMode, setPopupMode] = useState("");
    const { manageGoalLoading, goalData, MyGoalLoading, myGoalData} = useSelector(
      (state) => state?.EmployeeReducer?.ManageGoalReducer
    );    
    const closeMode = () => {
      setcreatepopup(false);
      setCurrentGoal(null);
      setOpenDialog(false);
      setPopupMode("");
    };
  const handleGoalPopup = (currentData, actionType) => {
    if(actionType === "Edit" || actionType === "Preview"){
      setcreatepopup(true);
      setPopupMode(actionType);
    }
    if(actionType === "Delete"){
      setOpenDialog(true);
    }
    setCurrentGoal(currentData);
  }
    const handleDeleteGaol = () => {
      dispatch(DeleteManageGoalAction({goal_pk: currentGoal?.goal_pk},
        (error, result) => {
            if (!error && result?.data?.statuscode === 200) {
            if(value === "1") {
              dispatch(GetMyGoalAction())
            }
            if(value === "2") {
              dispatch(GetManageGoalAction({alignment: "Team"}));
            }
            }
          }))
      setOpenDialog(false);
      closeMode();
    }
      const handleExportSelected = async(tab) => {
        setIsExporting(true);
        const exportGoalData = value === "1" ? myGoalData :  goalData;
          const headers = [
            { label: "Goal Category", key: "goal_category_name" },
            { label: "Goal", key: "goal_sub_category_name" },
            { label: "Goal Description", key: "goal_desc" }, 
            { label: "Weightage", key: "weight" },
            { label: "Due Date", key: "due_date" }, 
            { label: "Alignment", key: "alignment" },
            ...(tab === "Team"
                ? [{ label: "Assigned To", key: "employee_name" }]
                : []),
            { label: "Status", key: "goal_status" },
          ];
          const csvData = [headers.map(header => header.label)];
          exportGoalData?.forEach((row, index) => {
            const rowData = headers.map(header => {
                let value = row?.[header.key] ?? "";
                if (typeof value === "string" && value.includes(",")) {
                    value = `"${value}"`; 
                }
                return value;
            });
              csvData.push(rowData);
            });
        const csv = csvData.map(row => row.join(",")).join("\n");
        const blob = new Blob([csv], { type: "text/csv" });
        const url = URL.createObjectURL(blob);
        const downloadLink = document.createElement("a");
        downloadLink.href = url;
        downloadLink.download = tab === "Team" ? "My Team Goals.csv" :"My Goals.csv";
        downloadLink.setAttribute("target", "_blank");
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
        URL.revokeObjectURL(url);
        setIsExporting(false);
      };
  useEffect(() => {
    if(value === "1") {
      dispatch(GetMyGoalAction())
    }
    if(value === "2") {
      dispatch(GetManageGoalAction({alignment: "Team"}));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[value])
  return (
    <Box sx={{ maxHeight: "87vh", overflowY: "auto" }}>
      <Box
        sx={{
          position: "sticky",
          background: "#fff",
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <ArrowBackButton
          iconSize={18}
          onClick={() => {
            history.goBack();
          }}
        />
        <Typography
          sx={{
            fontFamily: "Nunito Sans",
            fontWeight: 700,
            color: "#000000",
            fontSize: "1.2rem",
          }}
        >
          Manage Goals
        </Typography>
        <Dashboard fontSize="small" />
      </Box>
      <Box>
        <TabContext value={value}>
          <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
            <TabList
            sx={{
                  minHeight: "40px",
                  ".MuiTab-root": { minHeight: "20px" },
                  "& .MuiTabs-indicator": {
                    width: "100%",
                    display: "flex",
                    justifyContent: "center !important",
                  },
                }}
              onChange={handleChange}
              aria-label="lab API tabs example"
            >
              <Tab
                label={
                  <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
                    <BookmarkBorder style={{ verticalAlign: "middle" }} /> My Goals
                  </div>
                }
                value="1"
              />
             {isAdminOwner() && (<Tab
                label={
                  <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
                    <BackupOutlined style={{ verticalAlign: "middle" }} /> My
                    Reportees Goals
                  </div>
                }
                value="2"
              />)}
              {isAdminOwner() && (<Tab
                label={
                  <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
                    <BackupOutlined style={{ verticalAlign: "middle" }} /> Goals Assigned By Me
                  </div>
                }
                value="3"
              />)}
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "flex-end",
                  pr: 2,
                  width: "100%",
                  height: 36,
                  mt: 0.5                  
                }}
              >
                <Button
                  type="submit"
                  variant="contained"
                  size="small"
                  className="mpl-primary-btn"
                  onClick={() => {
                    setcreatepopup(true);
                  }}
                >
                  <Add fontSize="small" />
                  Create Goal
                </Button>
              </Box>
            </TabList>
          </Box>
          <TabPanel value="1" sx={{ p: 1 }}>
            <Grid
              container
              sx={{ display: "flex", justifyContent: "flex-end" }}
            >
              <Grid item sm={3} md={3}>
                <SelectableSearch
                  label="Goal Planning"
                  value={yearplanvalue}
                  fieldLabel="label"
                  required={true}
                  variant={"contained"}
                  name="goalplanning"
                  size="small"
                  data={yearplan}
                  onChangeEvent={handleInputChange}
                  helperText={error}
                />
              </Grid>
              <Grid item ml={1}>
                <Tooltip title="Export">
                  <IconButton onClick={() =>handleExportSelected("Self")} disabled={isExporting}>
                    {isExporting ? <CircularProgress size={24} /> : <CloudDownloadIcon />}
                  </IconButton>
                </Tooltip>
              </Grid>
            </Grid>
            <Box sx={{ marginTop: 2}}>
              <Grid container spacing={2}>
                {MyGoalLoading ? Array.from(new Array(8)).map((_, idx) => (
                    <Grid item xs={12} sm={6} md={4} lg={3} key={idx}>
                      <GoalCardSkeleton />
                    </Grid>
                  ))
                : myGoalData?.length > 0 ? (
                  myGoalData?.map((goal, index) => (
                    <Grid item xs={12} sm={6} md={4} lg={3} key={index}>
                      <GoalCard goal={goal} handleGoalPopup={handleGoalPopup} tab={"Self"} />
                    </Grid>
                  ))
                ) : (
                   <Grid item xs={12}>
                     <Box
                      sx={{
                        height: "40vh",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <Typography
                        variant="h6"
                        color="text.secondary"
                        sx={{ textAlign: "center", px: 2 }}
                      >
                        No Data Available
                      </Typography>
                    </Box>
                  </Grid>
                )}
              </Grid>
            </Box>
          </TabPanel>
          <TabPanel value="2" sx={{ p: 1 }} >
            <Box sx={{ display: "flex", justifyContent: "space-between" }}>
              <TextField
                variant="outlined"
                value={searchValue}
                onChange={(e) => handlememberSearch(e)}
                id="grouporg_search"
                size="small"
                label="Search "
                sx={{ width: "20%" }}
              />
              <Grid item ml={1}>
                <Tooltip title="Export">
                  <IconButton onClick={() =>handleExportSelected("Team")} disabled={isExporting}>
                    {isExporting ? <CircularProgress size={24} /> : <CloudDownloadIcon />}
                  </IconButton>
                </Tooltip>
              </Grid>
            </Box>
            <Box sx={{ marginTop: 2}}>
              <Grid container spacing={2}>
                {manageGoalLoading ? Array.from(new Array(8)).map((_, idx) => (
                    <Grid item xs={12} sm={6} md={4} lg={3} key={idx}>
                      <GoalCardSkeleton />
                    </Grid>
                  ))
                : goalData?.length > 0 ? (
                  goalData?.map((goal, index) => (
                    <Grid item xs={12} sm={6} md={4} lg={3} key={index}>
                      <GoalCard goal={goal} handleGoalPopup={handleGoalPopup} tab={"Team"} />
                    </Grid>
                  ))
                ) : (
                   <Grid item xs={12}>
                     <Box
                      sx={{
                        height: "40vh",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <Typography
                        variant="h6"
                        color="text.secondary"
                        sx={{ textAlign: "center", px: 2 }}
                      >
                        No Data Available
                      </Typography>
                    </Box>
                  </Grid>
                )}
              </Grid>
            </Box>
          </TabPanel>
          <TabPanel value="3" sx={{ p: 1 }} >
            <Box sx={{ display: "flex", justifyContent: "space-between" }}>
              <TextField
                variant="outlined"
                value={searchValue}
                onChange={(e) => handlememberSearch(e)}
                id="grouporg_search"
                size="small"
                label="Search "
                sx={{ width: "20%" }}
              />
              <Grid item ml={1}>
                <Tooltip title="Export">
                  <IconButton onClick={() =>handleExportSelected("Team")} disabled={isExporting}>
                    {isExporting ? <CircularProgress size={24} /> : <CloudDownloadIcon />}
                  </IconButton>
                </Tooltip>
              </Grid>
            </Box>
            <Box sx={{ marginTop: 2}}>
              <Grid container spacing={2}>
                {manageGoalLoading ? Array.from(new Array(8)).map((_, idx) => (
                    <Grid item xs={12} sm={6} md={4} lg={3} key={idx}>
                      <GoalCardSkeleton />
                    </Grid>
                  ))
                : goalData?.length > 0 ? (
                  goalData?.map((goal, index) => (
                    <Grid item xs={12} sm={6} md={4} lg={3} key={index}>
                      <GoalCard goal={goal} handleGoalPopup={handleGoalPopup} tab={"Team"} />
                    </Grid>
                  ))
                ) : (
                   <Grid item xs={12}>
                     <Box
                      sx={{
                        height: "40vh",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <Typography
                        variant="h6"
                        color="text.secondary"
                        sx={{ textAlign: "center", px: 2 }}
                      >
                        No Data Available
                      </Typography>
                    </Box>
                  </Grid>
                )}
              </Grid>
            </Box>
          </TabPanel>
        </TabContext>
      </Box>
      <Popup
        title={currentGoal ? `${popupMode} Goal` : "Create New Goal"}
        openPopup={createpopup}
        setOpenPopup={closeMode}
        fullWidth={true}
        maxWidth="sm"
      >
      <CreateGoal
        setOpenPopup={setcreatepopup}
        closeMode={closeMode}
        currentGoal={currentGoal}
        mode={popupMode} 
        value={value}
      />
      </Popup>

      {/* <Acheivement
        data={data}
        setData={setData}
        goalname={goalname}
        openPopup={acheivementpopup}
        setOpenPopup={setAcheivementpopup}
      />
      <Activity
        data={data}
        setData={setData}
        openPopup={activitypopup}
        goalname={goalname}
        setOpenPopup={setactivitypopup}
      />
      <CheckIn
        data={data}
        setData={setData}
        openPopup={checkinpopup}
        goalname={goalname}
        setOpenPopup={setcheckinpopup}
        setOpenactivityPopup={setactivitypopup}
        linkedActivities={linkedActivities}
      /> */}
      {/* <ViewGoal
        data={data}
        setData={setData}
        goal={goal}
        openPopup={viewpopup}
        setOpenPopup={setviewpopup}
      />
      <EditGoal
        data={data}
        setData={setData}
        goal={goal}
        openPopup={editpopup}
        setOpenPopup={seteditpopup}
      /> */}
      <ConfirmationDialog
          title={"Delete Goal"}
          content={"Are you sure you want to proceed?"}
          openDialog={openDialog}
          closeDialog={setOpenDialog}
          OkButtonText="Yes"
          onSubmit={handleDeleteGaol}
        />
    </Box>
  );
}
